import { isAccountFeatureEnabled } from "owa-feature-flags";
import type { MailboxInfo } from "owa-client-types";
import { SubstrateSearchScenario } from "../data/schema/SubstrateSearchScenario";
import type SubstrateSearchEndpointTarget from "../data/schema/SubstrateSearchEndpointTarget";

type SubstrateSearchEndpoint = "suggestions" | "events" | "init" | "query" | "searchHistory" | "feedback" | "usercontrols";

export const GENWEB_SEARCH_ENDPOINT_PREFIX = "/messageservice/genwebsearch/";

export default function getSubstrateSearchEndpoint(endpoint: SubstrateSearchEndpoint, version?: number, scenario?: SubstrateSearchScenario, mailboxInfo?: MailboxInfo, endpointTarget: SubstrateSearchEndpointTarget = "Auto"): string {
    const isGenWebEndpoint = scenario === SubstrateSearchScenario.Mail &&
        (endpoint === "init" || endpoint === "suggestions" || endpoint === "query") &&
        (endpointTarget === "GenWeb" ||
            (endpointTarget === "Auto" &&
                !!mailboxInfo &&
                isAccountFeatureEnabled("sea-gwc-outlook-infra-latency-testing", mailboxInfo)));
    
    if (isGenWebEndpoint) {
        return `${GENWEB_SEARCH_ENDPOINT_PREFIX}${endpoint}`;
    }
    
    const versionPath = version === 3 ? "v3" : version === 2 ? "v2" : "v1";
    const searchPath = endpoint == "query" ? "searchservice" : "search";
    
    return `${searchPath}/api/${versionPath}/${endpoint}`;
}
